import React, { useEffect, useRef } from 'react';
import Quill from 'quill';
import 'quill/dist/quill.snow.css'; 

// Importar el plugin de UI para tablas
import * as QuillTableUI from 'quill-table-ui';
import 'quill-table-ui/dist/index.css';

const RichTextEditor = ({ value, onChange, onBlur }) => {
    const containerRef = useRef(null);   // Referencia al Wrapper (padre)
    const quillInstance = useRef(null);  // Instancia de Quill

    useEffect(() => {
        // 1. REGISTRO SEGURO DEL PLUGIN
        // Verificamos si ya existe para no registrarlo doble
        if (!Quill.imports['modules/tableUI']) {
        try {
            Quill.register({
            'modules/tableUI': QuillTableUI.default,
            }, true);
        } catch (e) {
            console.error("Error registering tableUI", e);
        }
        }

        const container = containerRef.current;
        
        // 2. CREACIÓN DINÁMICA DEL EDITOR
        // Creamos un div fresco cada vez que se monta.
        // Esto evita que Quill reutilice basura vieja del DOM.
        const editorDiv = document.createElement('div');
        container.appendChild(editorDiv);

        // 3. INICIALIZAR QUILL
        const quill = new Quill(editorDiv, {
        theme: 'snow',
        modules: {
            table: true,   // Motor interno de tablas (Quill v2)
            tableUI: true, // UI Flotante (Librería externa)
            toolbar: [
            ['bold', 'italic', 'underline', 'strike'],
            [{ list: 'ordered' }, { list: 'bullet' }],
            [{ header: [1, 2, 3, false] }],
            [{ color: [] }, { background: [] }],
            ['link'],
            ['clean'],
            ['table'], // Botón de tabla
            ],
        },
        });

        // 4. CARGA INICIAL DE DATOS
        if (value) {
        // Usamos clipboard.dangerouslyPasteHTML para mayor seguridad/compatibilidad
        quill.clipboard.dangerouslyPasteHTML(value);
        }

        // 5. ESCUCHAR CAMBIOS
        quill.on('text-change', () => {
            onChange(quill.root.innerHTML);
        });

        quillInstance.current = quill;

        // 6. LIMPIEZA TOTAL (Aquí arreglamos el doble toolbar)
        return () => {
        quillInstance.current = null;
        if (container) {
            // Al vaciar el contenedor padre, eliminamos:
            // 1. La barra de herramientas vieja (.ql-toolbar)
            // 2. El editor viejo (.ql-container)
            container.innerHTML = '';
        }
        };
    }, []); // Array vacío = Solo se ejecuta al montar

    useEffect(() => {
        const quill = quillInstance.current;
        
        // Verificamos que Quill exista y que tengamos un valor nuevo
        if (quill && value) {
        // Comparar para evitar bucles infinitos o saltos de cursor:
        // Solo actualizamos si el contenido que llega es diferente al que ya tiene Quill
        if (value !== quill.root.innerHTML) {
            // Usamos innerHTML para reemplazar todo el contenido limpiamente
            quill.root.innerHTML = value;
        }
        }
    }, [value]);

    return (
        <div className="rich-text-editor-wrapper">
            <style>
                {`
                    /* Estilos para la tabla */
                    .ql-editor table { 
                        border-collapse: collapse; 
                        width: 100%;
                    }
                    .ql-editor td { 
                        border: 1px solid #ccc; 
                        padding: 8px; 
                        min-width: 50px; 
                    }
                    /* Icono del botón tabla */
                    .ql-snow .ql-toolbar button.ql-table { 
                        width: auto !important; 
                        padding: 0 5px; 
                        font-weight: bold; 
                    }
                    .ql-snow .ql-toolbar button.ql-table:after { 
                        content: ' Tabla'; 
                        font-size: 12px; 
                    }
                `}
            </style>
        
            {/* Contenedor vacío que controlamos manualmente */}
            <div 
                ref={containerRef} 
                style={{ 
                    minHeight: '10px', 
                    backgroundColor: 'white' 
                }}
            >
                
            </div>
        </div>
    );
};

export default RichTextEditor;